// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"efad2d6e","732":"3041cd12","977":"e5f05493"}[chunkId] + ".chunk.js";
};